module.exports = __webpack_public_path__ + "5fdb1b0818564fdf37b1dfdfe40e5d79.fbx";